import React, {useState, useEffect} from 'react';
import {FaBars} from 'react-icons/fa';
import {animateScroll as scroll} from "react-scroll";
import { 
     Nav,
     NavBarContainer, 
     NavLogo, 
     MobileIcon, 
     NavMenu, 
     NavItem, 
     NavLinks,
     NavBtn,
     NavBtnLink
    } from './NavBarElem';

const Navbar = ({toggle}) => {
    const [scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if(window.scrollY >= 80){
            setScrollNav(true); 
        }
        else{
            setScrollNav(false); 
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, [])

    const toggleHome = () =>{
        scroll.scrollToTop();
    }



    return (
    <div>
        <Nav scrollNav={scrollNav}>
           <NavBarContainer>
            <NavLogo to='/' onClick={toggleHome}>
               Royal Navy Capital 
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />  
            </MobileIcon>
            <NavMenu>
                <NavItem>
                    <NavLinks to="about"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    >About</NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to="discover"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true">Discover</NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to="signup"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true">Sign Up</NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to="services" 
                    smooth={true}
                    duration={500}
                    spy={true}                    
                    exact="true">Services</NavLinks>
                </NavItem>
                <NavBtn>
                    <NavBtnLink to="/signin">Sign In</NavBtnLink>
                </NavBtn>
            </NavMenu>
            </NavBarContainer> 
        </Nav>
    </div>    
    );
};

export default Navbar;